// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:23:37.269Z
// Property: The Blakely (ID: 6767906449167333)
// Collections: 29 amenities, 4 floorplans (live), 50 photos, 32 POIs, 5 reviews, 4 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167333",
  "property_external_id": "100160120",
  "property_zillow_url": "https://www.zillow.com/apartments/pendergrass-ga/the-blakely/Cp2HTk/",
  "property_apartments_url": "https://www.apartments.com/the-blakely-pendergrass-ga/svk1pn6/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Blakely/data=!4m2!3m1!1s0x0:0x835c8a79e2c9791d?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "9725722006",
  "property_crm_software": "Entrata LeadManager",
  "property_pm_software": "Entrata",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-blakely",
  "property_name": "The Blakely",
  "property_website_url": "https://www.liveatblakely.com/",
  "property_domain": "https://www.liveatblakely.com/",
  "property_address": "542 Glenn Gee Rd",
  "property_full_address": "542 Glenn Gee Rd, Pendergrass, GA 30567",
  "property_address_1": "542 Glenn Gee Rd",
  "property_address_2": null,
  "property_address_city": "Pendergrass",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30567",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Jackson County",
  "property_address_latitude": "34.1551368",
  "property_address_longitude": "-83.6817126",
  "property_email": null,
  "property_phone": "(762) 232-2339",
  "property_call_tracking_phone": "8555136601",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Experience life at The Blakely in Pendergrass, GA, where modern elegance meets resort-style living. Choose from spacious one to three-bedroom floor plans, each with luxury finishes. Enjoy amenities like stunning pools, an outdoor kitchen, game room, and a bark park. Indulge in comfort—your perfect home awaits! Schedule a tour today!",
  "property_long_description": "**Welcome to The Blakely - Your Dream Apartment Community in Pendergrass, GA!**\n\nExperience luxury living at The Blakely, where modern comfort meets an array of exceptional amenities. Our thoughtfully designed apartment floor plans include one, two, and three-bedroom options, perfect for any lifestyle. Each residence features upscale touches such as granite countertops, wood-style flooring, and provided washers and dryers, ensuring a seamless and stylish living experience. \n\nStep outside your door to indulge in our resort-style amenities. Dive into one of our two stunning swimming pools, unwind by the fire pit areas, or host a gathering in the outdoor kitchens. For fitness enthusiasts, our state-of-the-art fitness center and game room provide everything you need to stay active and entertained. Movie lovers will adore our theater room, while nature enthusiasts can take a stroll through our well-maintained grounds or let their pets run free at our convenient bark park.\n\nSafety and convenience are paramount at The Blakely, with access gates, EV charging stations, and an on-site management and service team to assist you. Families will appreciate our playground and picnic areas, perfect for weekend fun.\n\nDon’t wait to find your new home in this vibrant community! Browse our availability today or schedule a tour to explore all that The Blakely has to offer. Experience the perfect balance of luxury and everyday living in Pendergrass, GA—where every day feels like a vacation!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e3bb-7736-95f1-968ea88d4078.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool and lounge chairs with apartment buildings in the background.",
    "public_id": "019d54f0-e3bb-7736-95f1-968ea88d4078",
    "storage_key": "property/6767906449167333/019d54f0-e3bb-7736-95f1-968ea88d4078.webp",
    "width": 2048,
    "height": 1042
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "419",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.02147971360382",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$500.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "60",
  "property_pet_restrictions": "breed restrictions apply",
  "property_pet_policy_description": "We welcome cats and dogs (breed restrictions apply). Maximum of 2 pets per unit. One-time pet fee: $400 - $800. Monthly pet rent: $50 per pet.",
  "property_petpolicy_info": "\nPet Policy\nPet Types: Cats & Dogs\n\nBreed Restrictions Apply\n\nMaximum Pets Per Unit: 2\n\nPet Fees\nFee: $400.00\n\nRent: $20.00",
  "property_online_leasing_url": "https://theblakelyaxia.prospectportal.com/Apartments/module/application_authentication/",
  "property_resident_portal_url": "https://theblakelyaxia.residentportal.com/auth",
  "property_apply_now_url": "https://theblakelyaxia.prospectportal.com/Apartments/module/application_authentication/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e0e2-7365-97b1-ec06a3916188.webp",
  "property_primary_logo_media": {
    "alt_text": "The Blakely logo",
    "public_id": "019d54f0-e0e2-7365-97b1-ec06a3916188",
    "storage_key": "property/6767906449167333/019d54f0-e0e2-7365-97b1-ec06a3916188.webp",
    "width": 190,
    "height": 133
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019ddf82-4a2b-7415-9f55-0532545ea814.webp",
  "property_fav_icon_media": {
    "alt_text": "Logo featuring the letter B inside a black circle with a white outline.",
    "public_id": "019ddf82-4a2b-7415-9f55-0532545ea814",
    "storage_key": "property/6767906449167333/019ddf82-4a2b-7415-9f55-0532545ea814.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d7437-b65f-72ce-8365-5bdfa2fb7227.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Blakely logo",
    "public_id": "019d7437-b65f-72ce-8365-5bdfa2fb7227",
    "storage_key": "property/6767906449167333/019d7437-b65f-72ce-8365-5bdfa2fb7227.webp",
    "width": 3072,
    "height": 693
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d7435-7ea7-759d-a354-b09fa1657910.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Blakely logo",
    "public_id": "019d7435-7ea7-759d-a354-b09fa1657910",
    "storage_key": "property/6767906449167333/019d7435-7ea7-759d-a354-b09fa1657910.webp",
    "width": 3072,
    "height": 693
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": "#a3acb2",
  "property_color_3": "#3c5c75",
  "property_color_5": "#b67a2b",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "855 - 1444",
  "property_sqft_min": "855",
  "property_sqft_max": "1444",
  "property_price_range": "$1424 - $2019",
  "property_price_min": "1424",
  "property_price_max": "2019",
  "property_available_units": 46,
  "property_facebook_url": "https://www.facebook.com/theblakelypendergrass",
  "property_instagram_url": "https://www.instagram.com/liveatblakely/",
  "property_twitter_url": "https://x.com/liveatblakely",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJebCMUHfl9YgRHXnJ4nmKXIM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-blakely-pendergrass",
  "property_tiktok_url": "https://www.tiktok.com/@blakelyapartments/video/7205702540875549998",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Blakely",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "Welcome to The Blakely in Pendergrass, GA, where luxury meets comfort. Choose from stylish one, two, and three-bedroom floor plans. Relax by our resort-style pools, enjoy outdoor kitchens, or unwind in the game room. With on-site management and pet-friendly amenities, your ideal lifestyle awaits. Embrace the allure of The Blakely today!",
  "property_home_floorplans_blurb": "Welcome to The Blakely in Pendergrass, GA, where comfort meets style! With thoughtfully designed one, two, and three-bedroom floor plans, there’s a perfect home waiting just for you. Elevate your living experience and browse our available apartments to find your ideal sanctuary today!",
  "property_home_gallery_blurb": "At The Blakely in Pendergrass, GA, your ideal lifestyle awaits! With spacious one, two, and three-bedroom floor plans and amenities like resort-style pools, a game room, and scenic views, every day feels like a getaway. Picture yourself lounging on the sundeck or enjoying the bark park with your furry friend!",
  "property_home_neighborhood_blurb": "At The Blakely in Pendergrass, GA, your ideal lifestyle awaits with spacious one, two, and three-bedroom floor plans. Embrace vibrant community living with convenient access to local parks, fitness centers like Anytime Fitness, and beloved venues such as the Jefferson Memorial Stadium. Immerse yourself in the charm of your new neighborhood!",
  "property_home_reviews_blurb": "At The Blakely in Pendergrass, GA, residents rave about the “welcoming atmosphere and attentive management.” Join a vibrant community where comfort meets convenience. Experience a lifestyle that truly feels like home, surrounded by exceptional amenities. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Embrace life at The Blakely in Pendergrass, GA, where vibrant community living meets convenience. Just moments away, explore lush parks like Sell's Mill and Braselton Park or hit the turf at Jefferson and Panther Stadiums. Fitness enthusiasts will love Anytime Fitness and The Rig Gym, ensuring an invigorating lifestyle.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Blakely in Pendergrass, GA, luxury meets comfort. Enjoy two resort-style swimming pools, outdoor kitchens, and a lively game room—perfect for gatherings. With spacious one, two, and three-bedroom floor plans featuring granite countertops and wood-style flooring, your dream home awaits. Experience relaxation and entertainment right at your doorstep!",
  "property_applynow_blurb": "At The Blakely in Pendergrass, GA, choose from spacious one, two, or three-bedroom floor plans that perfectly blend comfort and style. Enjoy resort-style amenities like sparkling swimming pools, outdoor kitchens, and a vibrant game room. Experience exceptional living—your new home awaits. Lease online today!",
  "property_contactus_blurb": "At The Blakely in Pendergrass, GA, our thoughtfully designed floor plans cater to every lifestyle, whether you're seeking a cozy one-bedroom or a spacious three-bedroom. Uncover your ideal space and let our friendly leasing team assist you. Have questions? Connect with us today!",
  "property_faqs_blurb": "At The Blakely in Pendergrass, GA, we offer thoughtfully designed one, two, and three-bedroom apartments to suit your lifestyle. Have questions about our community? Dive into our FAQs page for insightful answers and learn why The Blakely is the perfect place to call home!",
  "property_floorplans_blurb": "At The Blakely in Pendergrass, GA, your ideal living space awaits. Choose from beautifully designed one, two, or three-bedroom apartment homes that blend comfort and style. Each layout offers unique features tailored to your lifestyle. Browse our floor plans and step into a home that suits your every need.",
  "property_gallery_blurb": "At The Blakely in Pendergrass, GA, vibrant living meets unparalleled amenities. Picture yourself lounging by two stunning resort-style pools, hosting friends in our outdoor kitchens, or unwinding in the game room. With charming floor plans and scenic views, your dream home awaits. View our photo gallery to envision your future!",
  "property_interactivemap_blurb": "Nestled in the heart of Pendergrass, GA, The Blakely offers modern living with stylish one, two, and three-bedroom apartments. Enjoy a resort-style pool, game room, and state-of-the-art fitness center. Use our interactive community map to find your perfect home today and embrace a lifestyle of luxury and convenience!",
  "property_pets_blurb": "The Blakely cherishes your furry companions as much as you do, and we’re excited to welcome yours to our pet-friendly apartment community. Our thoughtfully designed homes and amenities cater not just to you but also to your pets, ensuring they feel right at home. For more details about our pet policy and how we can accommodate your beloved pet, please don’t hesitate to reach out to us.",
  "property_referafriend_blurb": "At The Blakely in Pendergrass, GA, your ideal home awaits, whether it's a cozy one-bedroom or a spacious three-bedroom. Invite friends to share in the community atmosphere—great friends make great neighbors! Help them find their perfect floor plan by referring a friend today!",
  "property_residentaccess_blurb": "At The Blakely in Pendergrass, GA, our diverse floor plans—including one, two, and three-bedroom options—cater to your lifestyle needs. Access your resident portal now to effortlessly pay rent, request maintenance, and stay connected to community updates. Experience convenience at your fingertips!",
  "property_reviews_blurb": "At The Blakely in Pendergrass, GA, residents rave about the community’s warmth and convenience, noting, “the staff is always attentive and the grounds are beautifully maintained.” Join a thriving neighborhood where comfort meets camaraderie! See what our residents have to say about living at our community!",
  "property_created_at": "1775246520026",
  "property_scheduletour_blurb": "At The Blakely in Pendergrass, GA, our thoughtfully designed floor plans—one, two, and three bedrooms—blend comfort with style. Ready to picture your future home? Schedule a tour today and hear firsthand from our residents about the vibrant community lifestyle that awaits you!",
  "property_thankyou_blurb": "Thank you for reaching out to The Blakely in Pendergrass, GA! With inviting one, two, and three-bedroom floor plans tailored for comfort, you’re one step closer to finding your perfect home. Our team looks forward to connecting with you soon—stay tuned for exciting updates!",
  "property_virtualtours_blurb": "At The Blakely in Pendergrass, GA, your ideal home awaits! With thoughtfully designed one, two, and three-bedroom floor plans, you're invited to experience comfort and style. Dive into our vibrant community from the comfort of your couch—take a virtual tour today and envision your new lifestyle!",
  "property_copyright": "2026 All Rights Reserved. The Blakely",
  "property_seo_title_home": "The Blakely |  Apartments in Pendergrass, GA",
  "property_seo_description_home": "Elevate your lifestyle at The Blakely in Pendergrass, GA! Enjoy resort-style amenities, modern finishes, and spacious floor plans. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Pendergrass, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Blakely in Pendergrass, GA! From cozy one bedrooms to spacious three bedrooms, your perfect floor plan awaits.",
  "property_seo_title_amenities": "Amenities | Pendergrass, GA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Blakely in Pendergrass, GA, with resort-style amenities, stylish apartments, and vibrant social spaces. Experience comfort and community!",
  "property_seo_title_gallery": "Gallery | Apartments in Pendergrass, GA",
  "property_seo_description_gallery": "Experience life at The Blakely in Pendergrass, GA. From stunning floor plans to resort-style amenities, picture your next chapter in our vibrant community!",
  "property_seo_title_virtualtours": "Virtual Tours | The Blakely Apartments",
  "property_seo_description_virtualtours": "Discover The Blakely in Pendergrass, GA—where modern comfort meets spacious living. Take a virtual tour of our stunning apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | The Blakely Apartments",
  "property_seo_description_interactivemap": "Discover life at The Blakely in Pendergrass, GA. Resort-style amenities and stylish floor plans await. Find your perfect home with our map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Pendergrass, GA",
  "property_seo_description_neighborhood": "Uncover the vibrant community of The Blakely in Pendergrass, GA. From local favorites to must-see spots, find your perfect neighborhood connections today!",
  "property_seo_title_contact": "Contact Us | The Blakely",
  "property_seo_description_contact": "Connect with The Blakely in Pendergrass, GA! Our leasing team is ready to answer your questions about our stylish one to three-bedroom apartments!",
  "property_seo_title_faqs": "FAQs | Apartments in Pendergrass, GA",
  "property_seo_description_faqs": "Find answers to your questions at The Blakely in Pendergrass, GA. Our community offers stylish living with top-notch amenities and welcoming spaces.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Pendergrass, GA",
  "property_seo_description_reviews": "Experience life at The Blakely in Pendergrass, GA! Dive into vibrant amenities, spacious layouts, and hear authentic resident tales of community bliss.",
  "property_seo_title_applynow": "Apply Now | Apartments in Pendergrass, GA",
  "property_seo_description_applynow": "Experience comfort at The Blakely in Pendergrass, GA. Choose from cozy one-bedrooms to spacious three-bedrooms and find your ideal home!",
  "property_seo_title_residentaccess": "Resident Access | The Blakely",
  "property_seo_description_residentaccess": "Log in to The Blakely resident portal for easy rent payment, maintenance requests, and exclusive community updates—your convenient living, all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | The Blakely",
  "property_seo_description_referafriend": "At The Blakely in Pendergrass, GA, great friends create vibrant communities. Refer a friend today and enjoy life together in your new apartment home!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Blakely",
  "property_seo_description_scheduletour": "Step into The Blakely in Pendergrass, GA—where comfort meets style. Schedule a tour today and envision your next home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | The Blakely",
  "property_seo_description_privacy": "At The Blakely in Pendergrass, GA, your privacy is our priority. Dive into our policy to see how we protect your personal information. Your trust matters!",
  "property_seo_title_accessibility": "Website Accessibility | The Blakely",
  "property_seo_description_accessibility": "At The Blakely in Pendergrass, GA, we prioritize digital inclusion and accessibility for a seamless experience for all residents.",
  "property_seo_title_sitemap": "Sitemap | The Blakely",
  "property_seo_description_sitemap": "Unearth the charm of The Blakely in Pendergrass, GA. Navigate our sitemap to find your perfect home among stunning amenities and vibrant community life!",
  "property_seo_title_thankyou": "Thank You | The Blakely",
  "property_seo_description_thankyou": "Thank you for reaching out! At The Blakely in Pendergrass, GA, your future home awaits. Our team is excited to assist you on this journey!",
  "property_seo_title_pets": "Pet Policy | Apartments in Pendergrass, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793462737",
  "amenities": [
    {
      "id": "custom_47fc2256-28bf-4e96-9262-f52e38ee97f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Coffee Bistro",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5994ad4-6291-4580-8afc-f71c8229d686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room with Entertainment Kitchen & Billard",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae696713-532c-467d-b9ef-185024f57e17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Style Pool with Sun Deck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ebecbc5-a1c2-4413-b1be-c2b85977d1ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center w/ On Demand Fitness",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_08132d94-2935-40ea-99ea-08b81ed62704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Multiple Fire Pits",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b13e1e8-1143-4a03-a212-d1d14eb22292",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Outdoor Kitchen with TVs",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6e3da9a-284c-4d1e-8931-78c5e871d969",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Community Clubhouse and Lounging",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b10415bc-62cd-41a7-a736-ed8550bd18a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers (Luxor)",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_011a6212-1b67-413f-b16a-b86de468ff16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c2160a4-f497-4d69-8bbb-2c57cc45d269",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Media Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63366f14-ee8d-432a-b45f-e94db3ecfcbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Co‑Working Spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0aaac465-dc0c-4c47-acde-8f4c6d3dd2c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park and Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_289b6850-b073-40a2-9073-cdb63ed9c591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_612a543c-6880-4c0e-aff4-b4a2eeaebd97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Cornhole",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31683485-acea-4cc5-847c-5df930417eb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Gated, Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0914058-086b-446e-bbce-683db336cfc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Oasis and Lounging",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8295e542-b767-4bf1-a3cc-d152b2878d90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Elegant Granite Counters with Tile Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c73cc9b-705d-440f-a9ae-42bcc4edfe3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Balconies and Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dd3d102c-5202-4311-b63e-b6dc48b3cfca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3cada9d-5441-49e5-acd8-51cc7fe984ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Nest Thermostat",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e6508cb-5191-4c61-b9fd-afc1a676885b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Soaking Tub",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dba7c0f6-7f4f-4cc5-8814-445b59125b89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Matte Black Accents",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8972cac3-7140-4ae4-b551-9c4ae7634556",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Shaker‑Style Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_75d16a3f-e1af-41f7-b4d4-d21151a63f08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washer and Dryer Included",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e82f5792-c501-4dd6-8ce6-f15a12985b1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c45f29f0-5b92-40e9-97ef-5088f297992a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Design Finishes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba4b26ec-3198-469a-880b-ec162ac15825",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless‑Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3a1428e-3b4f-47b0-a3e1-840aab434ecc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Tile Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca969ff5-f368-4a72-89a7-5d0bbcb76db9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d515d197-9a9e-4548-a7ba-9610711a677b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-9dad-7658-8945-45958c9da5dd.webp",
      "image_media": {
        "alt_text": "Community lounge area with a bar, high-top tables, and a large projector screen showing an aquarium at The Blakely, offering apartments in Pendergrass, GA.",
        "public_id": "019e02ca-9dad-7658-8945-45958c9da5dd",
        "storage_key": "property/6767906449167333/019e02ca-9dad-7658-8945-45958c9da5dd.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy movie nights or social gatherings in this stylish community lounge, featuring a full bar, comfortable seating, and a large projection screen for entertainment.",
      "link": "",
      "alt_text": "Community lounge area with a bar, high-top tables, and a large projector screen showing an aquarium at The Blakely, offering apartments in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e176e208-6adf-43a0-a77e-6ab576083400",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-735f-75fb-afe7-ab7853b98e66.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with a central clubhouse under a blue sky with clouds at The Blakely in Pendergrass, GA.",
        "public_id": "019e02ca-735f-75fb-afe7-ab7853b98e66",
        "storage_key": "property/6767906449167333/019e02ca-735f-75fb-afe7-ab7853b98e66.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Welcome to our beautiful community, featuring modern apartment buildings and a stunning clubhouse. Enjoy the convenience and comfort of your new home.",
      "link": "",
      "alt_text": "Modern apartment buildings with a central clubhouse under a blue sky with clouds at The Blakely in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_537456a4-748d-4a3c-91e2-51177e901384",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-965b-70ff-8c47-0b7e4f314c12.webp",
      "image_media": {
        "alt_text": "Golf cart parked in front of a modern apartment building's clubhouse with an accessible parking sign at The Blakely, offering apartments in Pendergrass, GA.",
        "public_id": "019e02ca-965b-70ff-8c47-0b7e4f314c12",
        "storage_key": "property/6767906449167333/019e02ca-965b-70ff-8c47-0b7e4f314c12.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover our vibrant community with convenient amenities like accessible parking and a modern clubhouse. Enjoy the resort-style living at our property.",
      "link": "",
      "alt_text": "Golf cart parked in front of a modern apartment building's clubhouse with an accessible parking sign at The Blakely, offering apartments in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a81f83a-8ef6-40cb-8fd4-071a63674940",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-80d5-74dd-96b8-b8fc6174f97e.webp",
      "image_media": {
        "alt_text": "View of a swimming pool and apartment buildings from a balcony with chairs at The Blakely, offering apartments in Pendergrass, GA.",
        "public_id": "019e02ca-80d5-74dd-96b8-b8fc6174f97e",
        "storage_key": "property/6767906449167333/019e02ca-80d5-74dd-96b8-b8fc6174f97e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and modern apartment buildings from your private balcony.",
      "link": "",
      "alt_text": "View of a swimming pool and apartment buildings from a balcony with chairs at The Blakely, offering apartments in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7d6c10c-b92e-46c7-91ee-aa1a3eaaacad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-aaab-731b-b0cb-60feb6a5c121.webp",
      "image_media": {
        "alt_text": "Community room with a large screen, projector, bar seating, and a counter area at The Blakely, offering apartments in Pendergrass, GA.",
        "public_id": "019e02ca-aaab-731b-b0cb-60feb6a5c121",
        "storage_key": "property/6767906449167333/019e02ca-aaab-731b-b0cb-60feb6a5c121.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy movie nights or social gatherings in our spacious community room, featuring a projector, screen, and comfortable seating.",
      "link": "",
      "alt_text": "Community room with a large screen, projector, bar seating, and a counter area at The Blakely, offering apartments in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8003e5a5-712c-4f29-a49c-e44e6a04ca36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-7703-7779-8ff7-dfad852dc9b5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings at The Blakely, offering apartments in Pendergrass, GA.",
        "public_id": "019e02ca-7703-7779-8ff7-dfad852dc9b5",
        "storage_key": "property/6767906449167333/019e02ca-7703-7779-8ff7-dfad852dc9b5.webp",
        "width": 3000,
        "height": 2003
      },
      "title": "Community",
      "description": "Relax by the resort-style swimming pool, complete with comfortable lounge chairs and stylish umbrellas. Enjoy the beautiful outdoor space at our community.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings at The Blakely, offering apartments in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b594bc8-dccc-4593-9ea2-f94f6382f12f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-509b-735b-ba31-79322e3ccd83.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, stationary bikes, and weight machines in a well-lit fitness center at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-509b-735b-ba31-79322e3ccd83",
        "storage_key": "property/6767906449167333/019e02ca-509b-735b-ba31-79322e3ccd83.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, stationary bikes, and weight machines in a well-lit fitness center at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71ed5905-676a-4c72-986a-8319d3e9334c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-4422-714d-bb05-9c7f43fa5d7e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings and clubhouse with landscaping at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-4422-714d-bb05-9c7f43fa5d7e",
        "storage_key": "property/6767906449167333/019e02ca-4422-714d-bb05-9c7f43fa5d7e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to your new home! Explore the beautiful exteriors and community spaces of our apartment complex.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings and clubhouse with landscaping at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6b82325-469c-4818-9c71-580ea8e6daa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-910a-7609-9e4c-880782d28bae.webp",
      "image_media": {
        "alt_text": "Modern common area with wooden bench, abstract art, and spacious seating.",
        "public_id": "019e02ca-910a-7609-9e4c-880782d28bae",
        "storage_key": "property/6767906449167333/019e02ca-910a-7609-9e4c-880782d28bae.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Experience the inviting atmosphere of our community's common area, featuring stylish decor and ample space for relaxation and socializing at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link": "",
      "alt_text": "Modern common area with wooden bench, abstract art, and spacious seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_556f2e45-e585-4dcc-8187-a903fa5c65df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-8c05-712f-86df-ba99f33deeef.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with surrounding apartment buildings at The Blakely in Pendergrass, GA.",
        "public_id": "019e02ca-8c05-712f-86df-ba99f33deeef",
        "storage_key": "property/6767906449167333/019e02ca-8c05-712f-86df-ba99f33deeef.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by modern apartment buildings and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with surrounding apartment buildings at The Blakely in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39bec49d-048e-4384-96be-6881f002a66d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-705c-76d7-bf53-fd8d9272dd77.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-705c-76d7-bf53-fd8d9272dd77",
        "storage_key": "property/6767906449167333/019e02ca-705c-76d7-bf53-fd8d9272dd77.webp",
        "width": 2942,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by comfortable lounge seating and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66cd02fb-189c-44e8-9fa7-2c134181e3e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-724c-71f1-bd7f-cc7ef79c484f.webp",
      "image_media": {
        "alt_text": "Exterior of a modern farmhouse style apartment building with a welcoming porch and landscaping at The Blakely in Pendergrass, GA.",
        "public_id": "019e02ca-724c-71f1-bd7f-cc7ef79c484f",
        "storage_key": "property/6767906449167333/019e02ca-724c-71f1-bd7f-cc7ef79c484f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover the inviting exterior of our community, featuring a charming farmhouse-inspired design with a well-maintained porch and lush landscaping.",
      "link": "",
      "alt_text": "Exterior of a modern farmhouse style apartment building with a welcoming porch and landscaping at The Blakely in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5be91160-a6d5-4dc9-99be-61bd02615786",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-64e2-76e6-82dc-ea93a90970db.webp",
      "image_media": {
        "alt_text": "Community lounge with shuffleboard, pool table, and seating areas at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-64e2-76e6-82dc-ea93a90970db",
        "storage_key": "property/6767906449167333/019e02ca-64e2-76e6-82dc-ea93a90970db.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy resident amenities like this spacious lounge featuring a shuffleboard, pool table, and multiple seating areas for relaxation and entertainment.",
      "link": "",
      "alt_text": "Community lounge with shuffleboard, pool table, and seating areas at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e090ebb-cd52-49c2-8530-a0e909c93e4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-6d3f-71e9-950b-4050a6dfb234.webp",
      "image_media": {
        "alt_text": "Spacious and modern lounge area with seating, coffee table, and TV at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-6d3f-71e9-950b-4050a6dfb234",
        "storage_key": "property/6767906449167333/019e02ca-6d3f-71e9-950b-4050a6dfb234.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring comfortable seating, a contemporary coffee table, and entertainment options.",
      "link": "",
      "alt_text": "Spacious and modern lounge area with seating, coffee table, and TV at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f27011d7-1df7-47ef-8b2d-f184d630150d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-4c97-73a7-81ca-3b0b680dc0ea.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and weight machines in a spacious fitness center at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-4c97-73a7-81ca-3b0b680dc0ea",
        "storage_key": "property/6767906449167333/019e02ca-4c97-73a7-81ca-3b0b680dc0ea.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, and weight machines in a spacious fitness center at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36a274d5-91e3-4f5c-8c68-69ac78c3711a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-fe0f-75b7-b02b-07df549d7b8c.webp",
      "image_media": {
        "alt_text": "Stylish resident lounge with a modern fireplace and TV, comfortable seating, and large windows at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02c9-fe0f-75b7-b02b-07df549d7b8c",
        "storage_key": "property/6767906449167333/019e02c9-fe0f-75b7-b02b-07df549d7b8c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed resident lounge, featuring a cozy fireplace, entertainment TV, and ample comfortable seating for all your needs.",
      "link": "",
      "alt_text": "Stylish resident lounge with a modern fireplace and TV, comfortable seating, and large windows at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7c944e88-e684-44dc-a417-4a85ead3f047",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-38c4-7337-b8ba-6396d299ecc7.webp",
      "image_media": {
        "alt_text": "Modern clubhouse interior with island, stairs, and large windows overlooking the pool at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-38c4-7337-b8ba-6396d299ecc7",
        "storage_key": "property/6767906449167333/019e02ca-38c4-7337-b8ba-6396d299ecc7.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Experience luxury living in our community clubhouse, featuring a stylish island, elegant staircase, and stunning views of the pool area through expansive windows.",
      "link": "",
      "alt_text": "Modern clubhouse interior with island, stairs, and large windows overlooking the pool at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_433a5479-64e1-49b1-b7fa-c1f651277f49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-38f4-7499-8b7d-98f629c2bb3e.webp",
      "image_media": {
        "alt_text": "Exterior of the clubhouse and leasing office with a welcoming entrance and landscaping at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-38f4-7499-8b7d-98f629c2bb3e",
        "storage_key": "property/6767906449167333/019e02ca-38f4-7499-8b7d-98f629c2bb3e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Step into the welcoming embrace of our clubhouse and leasing office, featuring a beautifully designed exterior and inviting entrance.",
      "link": "",
      "alt_text": "Exterior of the clubhouse and leasing office with a welcoming entrance and landscaping at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1222cc7f-1008-439a-a5b4-cb5191554830",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-4a5b-7266-b67d-ec1b026abb4f.webp",
      "image_media": {
        "alt_text": "The Blakely Luxury Apartments monument sign with colorful flowers in the foreground and apartment buildings in the background.",
        "public_id": "019e02ca-4a5b-7266-b67d-ec1b026abb4f",
        "storage_key": "property/6767906449167333/019e02ca-4a5b-7266-b67d-ec1b026abb4f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to The Blakely Luxury Apartments, where modern living meets comfort. Explore our beautiful community and find your perfect home.",
      "link": "",
      "alt_text": "The Blakely Luxury Apartments monument sign with colorful flowers in the foreground and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1f263d7-8768-4462-87ab-258adaa6625a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-39c4-7483-98fe-84cbd7bff674.webp",
      "image_media": {
        "alt_text": "Community bar area with a granite countertop, sink, and bar stools at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-39c4-7483-98fe-84cbd7bff674",
        "storage_key": "property/6767906449167333/019e02ca-39c4-7483-98fe-84cbd7bff674.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stylish community bar area with a granite countertop, modern bar stools, and decorative backsplash. Perfect for entertaining.",
      "link": "",
      "alt_text": "Community bar area with a granite countertop, sink, and bar stools at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e71cdcd0-b16f-42b6-994b-861761ac37d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-523a-7496-94cb-26cfc15613fd.webp",
      "image_media": {
        "alt_text": "Ping pong table and pool table in a common area with seating and stairs at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-523a-7496-94cb-26cfc15613fd",
        "storage_key": "property/6767906449167333/019e02ca-523a-7496-94cb-26cfc15613fd.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation in the community's game room, featuring a ping pong table and pool table, perfect for friendly competition or unwinding.",
      "link": "",
      "alt_text": "Ping pong table and pool table in a common area with seating and stairs at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dac40906-da4a-4a8a-97d9-a4e041774a0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-2b64-710c-93ff-4aab8f981160.webp",
      "image_media": {
        "alt_text": "Interior lounge area with view of pool and large train mural at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-2b64-710c-93ff-4aab8f981160",
        "storage_key": "property/6767906449167333/019e02ca-2b64-710c-93ff-4aab8f981160.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Spacious lounge with comfortable seating, a prominent train mural, and a view of the outdoor pool area. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Interior lounge area with view of pool and large train mural at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e686188-d3f7-4462-8038-df510b1d2292",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-fd6a-70a0-9cc5-732c7cf23c41.webp",
      "image_media": {
        "alt_text": "Modern communal area with a kitchenette, seating area, and large windows overlooking parking at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02c9-fd6a-70a0-9cc5-732c7cf23c41",
        "storage_key": "property/6767906449167333/019e02c9-fd6a-70a0-9cc5-732c7cf23c41.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the stylish communal spaces, complete with a convenient kitchenette and comfortable seating, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Modern communal area with a kitchenette, seating area, and large windows overlooking parking at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f184473-0790-48dd-86ba-6c8e3fb87075",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-f079-72ed-8928-3366c82ce4f4.webp",
      "image_media": {
        "alt_text": "Modern community lounge with oval table, chairs, and artwork at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02c9-f079-72ed-8928-3366c82ce4f4",
        "storage_key": "property/6767906449167333/019e02c9-f079-72ed-8928-3366c82ce4f4.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and connect in our stylish community lounge, featuring comfortable seating and contemporary decor.",
      "link": "",
      "alt_text": "Modern community lounge with oval table, chairs, and artwork at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8530cc86-8b66-47b8-a2da-ba06ccf75bad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-e404-75de-a9ee-06ff73c77599.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with a modern kitchen at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02c9-e404-75de-a9ee-06ff73c77599",
        "storage_key": "property/6767906449167333/019e02c9-e404-75de-a9ee-06ff73c77599.webp",
        "width": 2252,
        "height": 1500
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area, seamlessly flowing into a modern kitchen with a breakfast bar. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Open-concept living and dining area with a modern kitchen at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_347cae44-8854-43e0-b70a-7091dedd94cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-2d30-744e-9a56-9b055f3f8d6f.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with a large train mural, seating areas, and a bar at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-2d30-744e-9a56-9b055f3f8d6f",
        "storage_key": "property/6767906449167333/019e02ca-2d30-744e-9a56-9b055f3f8d6f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our expansive resident lounge, featuring a striking train mural, comfortable seating arrangements, and a modern bar area.",
      "link": "",
      "alt_text": "Spacious lounge area with a large train mural, seating areas, and a bar at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b068063-44a8-4331-ab46-e9858cc902ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-06ad-748a-94e1-d0c943d50ebf.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with modern furniture, a fireplace, and large windows at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-06ad-748a-94e1-d0c943d50ebf",
        "storage_key": "property/6767906449167333/019e02ca-06ad-748a-94e1-d0c943d50ebf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring comfortable seating, a cozy fireplace, and ample natural light.",
      "link": "",
      "alt_text": "Spacious community lounge area with modern furniture, a fireplace, and large windows at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e912d66a-f326-4ab4-843b-9112d8676204",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-e769-75fc-b8e3-74501bda2801.webp",
      "image_media": {
        "alt_text": "Spacious and modern community lounge area with comfortable seating and contemporary decor at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02c9-e769-75fc-b8e3-74501bda2801",
        "storage_key": "property/6767906449167333/019e02c9-e769-75fc-b8e3-74501bda2801.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring plush seating, modern design, and an inviting ambiance for residents.",
      "link": "",
      "alt_text": "Spacious and modern community lounge area with comfortable seating and contemporary decor at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63be35f0-7e9c-494a-9bd1-0ae691b4efab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02ca-1bfc-77d9-936f-aad06ddb7ccb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings and clubhouse with American flag at The Blakely, offering apartments for rent in Pendergrass, GA.",
        "public_id": "019e02ca-1bfc-77d9-936f-aad06ddb7ccb",
        "storage_key": "property/6767906449167333/019e02ca-1bfc-77d9-936f-aad06ddb7ccb.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to our community, featuring modern apartment buildings and a welcoming clubhouse.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings and clubhouse with American flag at The Blakely, offering apartments for rent in Pendergrass, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8068c770-f24a-45af-b055-485db053f091",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-fc97-724f-9a95-4c1695b00597.webp",
      "image_media": {
        "alt_text": "Modern living room with large TV, fireplace, and comfortable seating at The Blakely, offering apartments for rent near Braselton, GA.",
        "public_id": "019e02c9-fc97-724f-9a95-4c1695b00597",
        "storage_key": "property/6767906449167333/019e02c9-fc97-724f-9a95-4c1695b00597.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish communal living space, featuring a large screen TV, modern fireplace, and ample seating for socializing.",
      "link": "",
      "alt_text": "Modern living room with large TV, fireplace, and comfortable seating at The Blakely, offering apartments for rent near Braselton, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e22ce0b0-16ec-4c51-b18f-e9ded6dea8bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-e5f7-705e-b187-1bb035131c64.webp",
      "image_media": {
        "alt_text": "Spacious modern lounge area with comfortable seating, a fireplace, and a TV at The Blakely, offering apartments for rent near Braselton, GA.",
        "public_id": "019e02c9-e5f7-705e-b187-1bb035131c64",
        "storage_key": "property/6767906449167333/019e02c9-e5f7-705e-b187-1bb035131c64.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring plush seating, a cozy fireplace, and entertainment options.",
      "link": "",
      "alt_text": "Spacious modern lounge area with comfortable seating, a fireplace, and a TV at The Blakely, offering apartments for rent near Braselton, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5905fed-fe3b-476f-857f-4b23d397e0a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019e02c9-e5f6-706f-81ad-dbebfcf41d3e.webp",
      "image_media": {
        "alt_text": "Bar area with microwave and mini-fridge, overlooking a lounge area at The Blakely, offering apartments for rent near Braselton, GA.",
        "public_id": "019e02c9-e5f6-706f-81ad-dbebfcf41d3e",
        "storage_key": "property/6767906449167333/019e02c9-e5f6-706f-81ad-dbebfcf41d3e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the convenient bar area, complete with a microwave and mini-fridge, perfect for entertaining guests or relaxing after a long day. Overlooks a comfortable lounge area for our residents.",
      "link": "",
      "alt_text": "Bar area with microwave and mini-fridge, overlooking a lounge area at The Blakely, offering apartments for rent near Braselton, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7d671e9-50b6-4202-a370-686beb04c45a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f4-58d9-725f-b2d7-3d8ab43eba15.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops, white cabinets, and a bathtub with shower.",
        "public_id": "019d54f4-58d9-725f-b2d7-3d8ab43eba15",
        "storage_key": "property/6767906449167333/019d54f4-58d9-725f-b2d7-3d8ab43eba15.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Apartment",
      "description": "Bright and spacious bathroom featuring a double vanity with granite countertops, ample storage, and a clean white bathtub and shower combination.",
      "link": "",
      "alt_text": "Double vanity bathroom with granite countertops, white cabinets, and a bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ed4a050-d6e9-4138-93f4-09c76d1f946c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f4-0867-7299-8b5b-be0fd6a8a900.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools",
        "public_id": "019d54f4-0867-7299-8b5b-be0fd6a8a900",
        "storage_key": "property/6767906449167333/019d54f4-0867-7299-8b5b-be0fd6a8a900.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring an island with bar stools, sleek cabinetry, and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with island and bar stools",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5dd0b488-5f2c-48aa-bcaa-8d60ec491a4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f4-0248-74de-a440-c099071794c9.webp",
      "image_media": {
        "alt_text": "Exterior balcony with white railing and wooden deck overlooking a wooded area.",
        "public_id": "019d54f4-0248-74de-a440-c099071794c9",
        "storage_key": "property/6767906449167333/019d54f4-0248-74de-a440-c099071794c9.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Enjoy the outdoors on your private balcony, perfect for relaxing or entertaining with scenic views.",
      "link": "",
      "alt_text": "Exterior balcony with white railing and wooden deck overlooking a wooded area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d71b751d-2d7c-4811-9eab-3d96f3d6e5ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f4-01d7-7369-8f03-c9309e582be2.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in a modern apartment with a sectional sofa, ottoman, TV, and island with bar stools.",
        "public_id": "019d54f4-01d7-7369-8f03-c9309e582be2",
        "storage_key": "property/6767906449167333/019d54f4-01d7-7369-8f03-c9309e582be2.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a large TV, comfortable seating, and an open-concept kitchen with a breakfast bar. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area in a modern apartment with a sectional sofa, ottoman, TV, and island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9206af5d-33da-4a6f-9c7b-da89fbcaa068",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-e861-761e-9906-ff542256eba3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019d54f3-e861-761e-9906-ff542256eba3",
        "storage_key": "property/6767906449167333/019d54f3-e861-761e-9906-ff542256eba3.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6aafb167-695a-472a-9246-7bdbe43d417f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-b74d-748f-92c5-69ed7e3f0d6b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and walk-in shower.",
        "public_id": "019d54f3-b74d-748f-92c5-69ed7e3f0d6b",
        "storage_key": "property/6767906449167333/019d54f3-b74d-748f-92c5-69ed7e3f0d6b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom, featuring a double vanity with elegant granite countertops and a sleek walk-in shower.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0bc9f08d-96a5-4b9a-a0f2-9bad46b36c57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-bab0-70fa-aac5-77b480fdf464.webp",
      "image_media": {
        "alt_text": "Two twin beds in a bedroom with teal curtains and yellow accents.",
        "public_id": "019d54f3-bab0-70fa-aac5-77b480fdf464",
        "storage_key": "property/6767906449167333/019d54f3-bab0-70fa-aac5-77b480fdf464.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring two twin beds dressed in crisp white linens, accented with vibrant yellow and teal throw pillows and blankets. Teal curtains frame the window, and decorative wall art adds a bohemian touch.",
      "link": "",
      "alt_text": "Two twin beds in a bedroom with teal curtains and yellow accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9fd8166-68ae-4d6e-a5f9-41509653a5c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-af81-72e4-8f1e-038270f2a9d5.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, decorative pillows, a plush armchair, and a ceiling fan.",
        "public_id": "019d54f3-af81-72e4-8f1e-038270f2a9d5",
        "storage_key": "property/6767906449167333/019d54f3-af81-72e4-8f1e-038270f2a9d5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, a cozy armchair, and ample natural light.",
      "link": "",
      "alt_text": "Spacious bedroom with a king-size bed, decorative pillows, a plush armchair, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d3e7d30-e9d9-4feb-a5f5-2555e4125b2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-9b71-72a8-b8a2-ce7f76399765.webp",
      "image_media": {
        "alt_text": "Living room with a large painting of train tracks, a black credenza, a sofa, and a ceiling fan.",
        "public_id": "019d54f3-9b71-72a8-b8a2-ce7f76399765",
        "storage_key": "property/6767906449167333/019d54f3-9b71-72a8-b8a2-ce7f76399765.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a large piece of art depicting train tracks, a sleek black credenza, comfortable sofa, and decorative woven tables, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a large painting of train tracks, a black credenza, a sofa, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7934d3b7-3007-4764-8c6e-042e593a1493",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-96b9-7369-b34b-c821259130b4.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, plush bedding, and a stylish accent chair.",
        "public_id": "019d54f3-96b9-7369-b34b-c821259130b4",
        "storage_key": "property/6767906449167333/019d54f3-96b9-7369-b34b-c821259130b4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our well-appointed bedrooms, featuring a queen-size bed and elegant decor.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, plush bedding, and a stylish accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_982aa09a-c452-48af-97da-9cff989f137a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-9a4d-72bc-8a53-60087ccd90f7.webp",
      "image_media": {
        "alt_text": "Stackable Whirlpool washer and dryer unit in a closet.",
        "public_id": "019d54f3-9a4d-72bc-8a53-60087ccd90f7",
        "storage_key": "property/6767906449167333/019d54f3-9a4d-72bc-8a53-60087ccd90f7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit stackable Whirlpool washer and dryer for your laundry needs.",
      "link": "",
      "alt_text": "Stackable Whirlpool washer and dryer unit in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11856258-91c2-4538-9112-58154821ffd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-96d7-75c5-9176-fe5ada3fdb6d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with granite countertop.",
        "public_id": "019d54f3-96d7-75c5-9176-fe5ada3fdb6d",
        "storage_key": "property/6767906449167333/019d54f3-96d7-75c5-9176-fe5ada3fdb6d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a spacious bathtub and shower combination, a stylish vanity with a granite countertop, and a convenient toilet.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_687a53c8-6ecc-4fbe-b08d-04abe6d59a3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-8fc9-7673-9631-0f7d17a54347.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and abstract art on the wall.",
        "public_id": "019d54f3-8fc9-7673-9631-0f7d17a54347",
        "storage_key": "property/6767906449167333/019d54f3-8fc9-7673-9631-0f7d17a54347.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a round table with plush chairs and a striking abstract art piece, complemented by soft grey curtains and natural light.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and abstract art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09847c05-62f1-4262-9084-1c08ddc0fbae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-835d-704d-b79b-f1474ed7ff32.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019d54f3-835d-704d-b79b-f1474ed7ff32",
        "storage_key": "property/6767906449167333/019d54f3-835d-704d-b79b-f1474ed7ff32.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample cabinet space, and elegant granite countertops, perfect for preparing gourmet meals.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0ee0822-4dfa-4c26-8760-84b597a2cc52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-74ce-71dc-89d7-c1ff20892c04.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island with seating.",
        "public_id": "019d54f3-74ce-71dc-89d7-c1ff20892c04",
        "storage_key": "property/6767906449167333/019d54f3-74ce-71dc-89d7-c1ff20892c04.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and a convenient island with seating, perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1ff64295-e9df-46cc-ac12-3dbd473a17df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-7334-731a-b159-957e1608f966.webp",
      "image_media": {
        "alt_text": "Modern apartment living room and kitchen with island, couch, and dining table.",
        "public_id": "019d54f3-7334-731a-b159-957e1608f966",
        "storage_key": "property/6767906449167333/019d54f3-7334-731a-b159-957e1608f966.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area with a modern kitchen island, comfortable seating, and stylish decor.",
      "link": "",
      "alt_text": "Modern apartment living room and kitchen with island, couch, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c074fe6-1d09-4e53-aac6-1264c3478e45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-4db7-70e4-9edd-774abbbd8897.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with various weight machines, treadmills, and a wall of mirrors.",
        "public_id": "019d54f3-4db7-70e4-9edd-774abbbd8897",
        "storage_key": "property/6767906449167333/019d54f3-4db7-70e4-9edd-774abbbd8897.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Well-equipped fitness center with various weight machines, treadmills, and a wall of mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51c1707e-ddf4-434e-a850-6baf0ce28c96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f3-49ed-77ae-872b-0aa8edbcb6ab.webp",
      "image_media": {
        "alt_text": "Treadmills and ellipticals in the apartment fitness center.",
        "public_id": "019d54f3-49ed-77ae-872b-0aa8edbcb6ab",
        "storage_key": "property/6767906449167333/019d54f3-49ed-77ae-872b-0aa8edbcb6ab.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring treadmills, ellipticals, and a mirrored wall.",
      "link": "",
      "alt_text": "Treadmills and ellipticals in the apartment fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_346049a1-b17b-4762-81e9-a67b588cff63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "301 Exchange Way, Braselton, GA 30517, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-3b4f-717a-9a4a-26ec8531a3e7.webp",
      "poi_featured_image_media": {
        "alt_text": "Cracker Barrel Old Country Store with rocking chairs and flowers.",
        "public_id": "019d54f0-3b4f-717a-9a4a-26ec8531a3e7",
        "storage_key": "property/6767906449167333/019d54f0-3b4f-717a-9a4a-26ec8531a3e7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ga/braselton/588/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=14611108337345045169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "34.1187445",
      "poi_longitude": "-83.7634424",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-658-0009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54f0-e8ac-73cf-affe-0dd645103733",
        "storage_key": "property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD1gEaH3v9YgRsSIzrp4Vxco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_891dae45-5a44-40a9-939d-94c9366f156e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Cotton Calf Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "9924 Davis St #9, Braselton, GA 30517, USA",
      "poi_short_description": "Contemporary steakhouse serving seafood & other American fare in a converted historic space.",
      "poi_long_description": "People say this steakhouse serves delicious tomahawk steak, calamari, and mac and cheese. They highlight the generous portions, shareable sides, and excellent wine selection. They also like the upscale vibe and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-518b-71aa-92b0-4bb618a568c4.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Cotton Calf Kitchen building with a brick facade and large windows.",
        "public_id": "019d54f0-518b-71aa-92b0-4bb618a568c4",
        "storage_key": "property/6767906449167333/019d54f0-518b-71aa-92b0-4bb618a568c4.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.cottoncalf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6464813419165025644&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cotton-calf-kitchen",
      "poi_latitude": "34.1093177",
      "poi_longitude": "-83.76208489999999",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-684-0410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54f0-e8ac-73cf-affe-0dd645103733",
        "storage_key": "property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAwWUYorl9YgRbIWCfI2ht1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0790d149-b941-4a06-8797-71a7b07d2662",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Local Station",
      "poi_type": "Restaurants",
      "poi_address": "108 Brassie Ln, Braselton, GA 30517, USA",
      "poi_short_description": "Relaxed, beachfront-feeling spot offering burgers and other classic fare such as seafood and salads.",
      "poi_long_description": "People say this restaurant serves delicious lobster rolls, shrimp risotto, and blackened fish tacos. They highlight the generous portions, the fun and quaint atmosphere, and the pleasant patio seating. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-3d9c-72a6-91a0-aa0eeafd99d1.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor bar and lounge area at Local Station.",
        "public_id": "019d54f0-3d9c-72a6-91a0-aa0eeafd99d1",
        "storage_key": "property/6767906449167333/019d54f0-3d9c-72a6-91a0-aa0eeafd99d1.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://facebook.com/Local-Station-632795316907113/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11781072654736766602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "local-station",
      "poi_latitude": "34.1089335",
      "poi_longitude": "-83.76309119999999",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-921-4192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54f0-e8ac-73cf-affe-0dd645103733",
        "storage_key": "property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9JAMmDv9YgRijanIinHfqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fe921bc9-6fe5-449d-b0fe-6860695ee972",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Moonshiners Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "6750 Hwy 53, Braselton, GA 30517, USA",
      "poi_short_description": "Casual bar and grill with a large beer selection, live music, and activities like karaoke, pool, and darts.",
      "poi_long_description": "People say this bar and grill serves delicious burgers, a wide variety of drinks, and tasty food. They also highlight the friendly staff, live music, and fun atmosphere with pool tables, darts, and video golf.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-3e08-70c9-987b-6eb6ae2f4cc5.webp",
      "poi_featured_image_media": {
        "alt_text": "The exterior entrance of Moonshiners Bar & Grill with a monument sign.",
        "public_id": "019d54f0-3e08-70c9-987b-6eb6ae2f4cc5",
        "storage_key": "property/6767906449167333/019d54f0-3e08-70c9-987b-6eb6ae2f4cc5.webp",
        "width": 2544,
        "height": 3072
      },
      "poi_business_url": "http://moonshiners.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10010485640393859431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moonshiners-bar--grill",
      "poi_latitude": "34.1314163",
      "poi_longitude": "-83.7661285",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-684-0295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e8b1-775d-80d9-975427081862.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a martini glass",
        "public_id": "019d54f0-e8b1-775d-80d9-975427081862",
        "storage_key": "property/6767906449167333/019d54f0-e8b1-775d-80d9-975427081862.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2VdXEqLv9YgRZyHT8KZj7Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_9d4919a1-8f58-4687-bc05-2453d8673108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Millhouse Station",
      "poi_type": "Restaurants",
      "poi_address": "11 Smith Bridges St, Pendergrass, GA 30567, USA",
      "poi_short_description": "Relaxed venue for coffee and American meals such as burgers, fries and sandwiches.",
      "poi_long_description": "Diners say this American restaurant serves delicious burgers, sandwiches, and chicken salad, with many raving about the homemade ketchup and fries. They also highlight the friendly staff and the welcoming, clean, and stylish atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-4057-75ac-b3bb-913d47efca94.webp",
      "poi_featured_image_media": {
        "alt_text": "Millhouse Station Bar & Grill exterior with outdoor seating and a colorful mural.",
        "public_id": "019d54f0-4057-75ac-b3bb-913d47efca94",
        "storage_key": "property/6767906449167333/019d54f0-4057-75ac-b3bb-913d47efca94.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.millhousestationdining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3546577345107611048&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "millhouse-station",
      "poi_latitude": "34.162525",
      "poi_longitude": "-83.678454",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-929-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54f0-e8ac-73cf-affe-0dd645103733",
        "storage_key": "property/6767906449167333/019d54f0-e8ac-73cf-affe-0dd645103733.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-TLxEjl9YgRqE2WB075NzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_da4b465c-4c40-4245-acbd-b6b94043f965",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1685 Old Pendergrass Rd, Jefferson, GA 30549, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers fast and efficient Clicklist service, a great selection of products including the Simple Truth brand, and a discount gas program for members. They also highlight the amazing and helpful customer service that goes above and beyond, and the pleasant experiences they've had with the staff in every department.\n\nSome reviews mention the products can be out of stock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-4b4a-749f-82f3-280b0db58d1a.webp",
      "poi_featured_image_media": {
        "alt_text": "Kroger Food & Pharmacy store exterior at night with illuminated sign.",
        "public_id": "019d54f0-4b4a-749f-82f3-280b0db58d1a",
        "storage_key": "property/6767906449167333/019d54f0-4b4a-749f-82f3-280b0db58d1a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/jefferson/loggins-corner/011/00638?cid=loc_01100638_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3704290862334529510&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "34.1219171",
      "poi_longitude": "-83.60702189999999",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-387-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f0-e919-736f-bce0-1285d5b3fbf4",
        "storage_key": "property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUXN1oYni9YgR5s8swulIaDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_db311237-9932-4fd4-a4d6-6d70f989d11d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Publix Super Market at West Jackson Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "6055 GA-124, Hoschton, GA 30548, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide variety of items and delicious food, including strawberry banana parfaits. They highlight the clean store and friendly staff. They also like the helpful pharmacy staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-3b49-7162-ae24-3810e7caf4ba.webp",
      "poi_featured_image_media": {
        "alt_text": "Publix bakery interior with cakes and baked goods.",
        "public_id": "019d54f0-3b49-7162-ae24-3810e7caf4ba",
        "storage_key": "property/6767906449167333/019d54f0-3b49-7162-ae24-3810e7caf4ba.webp",
        "width": 1080,
        "height": 1920
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1188&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=4744981952523320961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-west-jackson-crossing",
      "poi_latitude": "34.1067017",
      "poi_longitude": "-83.70372760000001",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 706-654-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f0-e919-736f-bce0-1285d5b3fbf4",
        "storage_key": "property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3g7U0Hk9YgRgb7KIfKP2UE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_4914e169-67f0-40d1-b41b-83ebbccf2249",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Publix Super Market at Gateway Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "51 Old Farm Rd, Jefferson, GA 30549, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, meats, and other groceries, as well as a great deli and bakery. They highlight the clean and well-maintained building, and the friendly and helpful staff. They also like the buy-one-get-one-free sales.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-4c08-7135-98cc-cd93ccdfd10f.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Publix grocery store with 'Now Open' signs.",
        "public_id": "019d54f0-4c08-7135-98cc-cd93ccdfd10f",
        "storage_key": "property/6767906449167333/019d54f0-4c08-7135-98cc-cd93ccdfd10f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=9388339585582802991&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-gateway-crossing",
      "poi_latitude": "34.12548810000001",
      "poi_longitude": "-83.6047554",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-708-5216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f0-e919-736f-bce0-1285d5b3fbf4",
        "storage_key": "property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fYVvi0J9ogRL6hmjRwVSoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_74864d36-17c4-4065-8eb9-3f9ea8b36a1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "175 Peachtree Exchange Blvd, Hoschton, GA 30548, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this grocery store offers a wide variety of products, including groceries, clothing, and household items. They highlight the spacious layout, clean and modern design, and convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-3b48-7047-b05a-a390d870fc7f.webp",
      "poi_featured_image_media": {
        "alt_text": "Kroger grocery store exterior with pharmacy entrance.",
        "public_id": "019d54f0-3b48-7047-b05a-a390d870fc7f",
        "storage_key": "property/6767906449167333/019d54f0-3b48-7047-b05a-a390d870fc7f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/hoschton/hoschton/011/00686?cid=loc_01100686_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=604788701917087521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "34.0907145",
      "poi_longitude": "-83.75703850000001",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-921-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f0-e919-736f-bce0-1285d5b3fbf4",
        "storage_key": "property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-qKXQDl9YgRIQfwvR6kZAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_05f23972-3bec-47b6-983d-138e0f4ab413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1718 Old Pendergrass Rd, Jefferson, GA 30549, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide variety of groceries, including produce, bread, and seasonal items. They highlight the exceptional prices and good quality items. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-3b47-775e-a5a6-13963167169a.webp",
      "poi_featured_image_media": {
        "alt_text": "ALDI logo on the storefront at dusk",
        "public_id": "019d54f0-3b47-775e-a5a6-13963167169a",
        "storage_key": "property/6767906449167333/019d54f0-3b47-775e-a5a6-13963167169a.webp",
        "width": 1080,
        "height": 1920
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/jefferson/1718-old-pendergrass-road/l969",
      "poi_directions_map_url": "https://maps.google.com/?cid=11472186687409574074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "34.124351",
      "poi_longitude": "-83.60711200000001",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f0-e919-736f-bce0-1285d5b3fbf4",
        "storage_key": "property/6767906449167333/019d54f0-e919-736f-bce0-1285d5b3fbf4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Qz50L3j9YgRulADjAJlNZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_1650bffe-836b-429f-b1da-b4b2b34c7d4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Jefferson Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "127 Memorial Dr, Jefferson, GA 30549, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-66fd-762e-ac1c-41843b5003aa.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a football field with bleachers and a building.",
        "public_id": "019d54f0-66fd-762e-ac1c-41843b5003aa",
        "storage_key": "property/6767906449167333/019d54f0-66fd-762e-ac1c-41843b5003aa.webp",
        "width": 900,
        "height": 703
      },
      "poi_business_url": "http://www.jeffcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13516847383966925346&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jefferson-memorial-stadium",
      "poi_latitude": "34.113192",
      "poi_longitude": "-83.59151419999999",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-367-2881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e971-761f-911c-6fa7a421e084.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized graphic of two figures sitting at a table.",
        "public_id": "019d54f0-e971-761f-911c-6fa7a421e084",
        "storage_key": "property/6767906449167333/019d54f0-e971-761f-911c-6fa7a421e084.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV1nEENYJ9ogRIkKElBR9lbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b33738ae-c4e6-41c5-b1d7-8101c7d336eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Panther Stadium",
      "poi_type": "Entertainment",
      "poi_address": "152 Jaxco Jct, Hoschton, GA 30548, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-6a30-7468-ac3f-6396075b9f15.webp",
      "poi_featured_image_media": {
        "alt_text": "Jackson County High School football stadium with a team practicing on the field.",
        "public_id": "019d54f0-6a30-7468-ac3f-6396075b9f15",
        "storage_key": "property/6767906449167333/019d54f0-6a30-7468-ac3f-6396075b9f15.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://stadiumconnection.com/ga/stadium.php?id=5497",
      "poi_directions_map_url": "https://maps.google.com/?cid=17411348077407655680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panther-stadium",
      "poi_latitude": "34.1133455",
      "poi_longitude": "-83.68398619999999",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e971-761f-911c-6fa7a421e084.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized graphic of two figures sitting at a table.",
        "public_id": "019d54f0-e971-761f-911c-6fa7a421e084",
        "storage_key": "property/6767906449167333/019d54f0-e971-761f-911c-6fa7a421e084.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_arNrcDl9YgRAFeQvtOIofE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0378a86b-4520-426f-917e-5b9fe1dbb590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "The Arena",
      "poi_type": "Entertainment",
      "poi_address": "Jefferson, GA 30549, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-6975-7486-8c24-6352a78e60e6.webp",
      "poi_featured_image_media": {
        "alt_text": "Wrestling tournament in a gymnasium with spectators in the stands.",
        "public_id": "019d54f0-6975-7486-8c24-6352a78e60e6",
        "storage_key": "property/6767906449167333/019d54f0-6975-7486-8c24-6352a78e60e6.webp",
        "width": 1080,
        "height": 1920
      },
      "poi_business_url": "http://www.jeffcityschools.org/jefferson_websites/jefferson_city_athletics/facilities.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=11615266909618784255&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-arena",
      "poi_latitude": "34.1234641",
      "poi_longitude": "-83.5822745",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwTyC8i0I9ogR_0ctx7a3MaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_259cea33-9a24-4cc8-b615-a2bddbb68a7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Hoschton Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3434 Hwy 53, Hoschton, GA 30548, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-7ed0-7415-b58a-41005a8d30d7.webp",
      "poi_featured_image_media": {
        "alt_text": "A black dog sniffs a tortoise.",
        "public_id": "019d54f0-7ed0-7415-b58a-41005a8d30d7",
        "storage_key": "property/6767906449167333/019d54f0-7ed0-7415-b58a-41005a8d30d7.webp",
        "width": 3072,
        "height": 1729
      },
      "poi_business_url": "https://hoschtonanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=673722510779810037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hoschton-animal-hospital",
      "poi_latitude": "34.0886292",
      "poi_longitude": "-83.753818",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-395-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZc2hfzl9YgR9QA31A2LWQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_379f939b-0a0b-47a5-b0e2-a3f9ae0fe8cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Shannon Veterinary Services",
      "poi_type": "Health and Wellness",
      "poi_address": "1125 Storey Ln, Jefferson, GA 30549, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-7078-74e9-a262-5efd6f49e703.webp",
      "poi_featured_image_media": {
        "alt_text": "A German Shepherd dog wearing reindeer antlers sits in front of a Christmas tree made of branches and ornaments.",
        "public_id": "019d54f0-7078-74e9-a262-5efd6f49e703",
        "storage_key": "property/6767906449167333/019d54f0-7078-74e9-a262-5efd6f49e703.webp",
        "width": 609,
        "height": 960
      },
      "poi_business_url": "http://shannonvetservices.com/index.html?utm_source=Google&utm_medium=Website&utm_campaign=Google_NEXT",
      "poi_directions_map_url": "https://maps.google.com/?cid=5561001962126724537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shannon-veterinary-services",
      "poi_latitude": "34.1505925",
      "poi_longitude": "-83.60855269999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-367-1198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb43eHbni9YgRuU3QM9KlLE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_a2031cf0-8f73-4103-9b23-22a407000dd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Galilee Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3340 Winder Hwy, Jefferson, GA 30549, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-72c9-765b-a87d-dc2e810d0ab6.webp",
      "poi_featured_image_media": {
        "alt_text": "A small, scruffy black dog with a white chest and a pink collar lies on a gray towel on a metal table.",
        "public_id": "019d54f0-72c9-765b-a87d-dc2e810d0ab6",
        "storage_key": "property/6767906449167333/019d54f0-72c9-765b-a87d-dc2e810d0ab6.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.galileevethospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16238223702123689058&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "galilee-veterinary-hospital",
      "poi_latitude": "34.0915526",
      "poi_longitude": "-83.6195739",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-387-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0xw8Dvi9YgRYjRpXGzCWeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_48b0fec7-c96b-4df9-a385-863803279592",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Moss and Mane Hair Co.",
      "poi_type": "Health and Wellness",
      "poi_address": "55 Freedom Pkwy #203, Hoschton, GA 30548, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-7256-73a1-9cd3-b2c0ea56a90d.webp",
      "poi_featured_image_media": {
        "alt_text": "Group of women smiling and posing for a photo.",
        "public_id": "019d54f0-7256-73a1-9cd3-b2c0ea56a90d",
        "storage_key": "property/6767906449167333/019d54f0-7256-73a1-9cd3-b2c0ea56a90d.webp",
        "width": 1440,
        "height": 954
      },
      "poi_business_url": "https://mossandmanehairco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10797037829549406440&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moss-and-mane-hair-co",
      "poi_latitude": "34.1059025",
      "poi_longitude": "-83.6974244",
      "poi_miles_from_property": "12",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-684-0489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzBjiVrl9YgR6Di_aLPI1pU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_3f7ae2b9-5719-4017-abf3-98803106f524",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "The Men's Room Barber & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "6750 Hwy 53 #107, Braselton, GA 30517, USA",
      "poi_short_description": "Hip men's salon with a coffee bar & TVs offering haircuts & shaves, plus facials, waxing & massages.",
      "poi_long_description": "Hip men's salon with a coffee bar & TVs offering haircuts & shaves, plus facials, waxing & massages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-776b-715e-991a-c21ffc22f75e.webp",
      "poi_featured_image_media": {
        "alt_text": "The Men's Room Barber & Spa storefront with hours and services listed.",
        "public_id": "019d54f0-776b-715e-991a-c21ffc22f75e",
        "storage_key": "property/6767906449167333/019d54f0-776b-715e-991a-c21ffc22f75e.webp",
        "width": 1800,
        "height": 1200
      },
      "poi_business_url": "https://www.themensroombarberandspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4050483338523634685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-mens-room-barber--spa",
      "poi_latitude": "34.131772",
      "poi_longitude": "-83.766216",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-643-8186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgW0rd4Hv9YgR_etW0SI1Njg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_0344bfa4-6bcb-40bc-86c2-17a51af39cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Pro Cheer Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "84 Pearl Industrial Ave, Hoschton, GA 30548, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-75f2-7418-acd9-caae5f3a9a7e.webp",
      "poi_featured_image_media": {
        "alt_text": "A cheerleading team performs a stunt on stage with multiple members in uniform.",
        "public_id": "019d54f0-75f2-7418-acd9-caae5f3a9a7e",
        "storage_key": "property/6767906449167333/019d54f0-75f2-7418-acd9-caae5f3a9a7e.webp",
        "width": 828,
        "height": 584
      },
      "poi_business_url": "https://www.go-procheer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7508974511784925456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pro-cheer-training-center",
      "poi_latitude": "34.0835583",
      "poi_longitude": "-83.7420388",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 706-658-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e90e-73a9-8714-c92931ca737c.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f0-e90e-73a9-8714-c92931ca737c",
        "storage_key": "property/6767906449167333/019d54f0-e90e-73a9-8714-c92931ca737c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvT6pBODl9YgREBlnwog8NWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_53c132aa-6e9b-44c9-abed-225137aad1be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "The Rig Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "84 Pearl Industrial Ave, Hoschton, GA 30548, USA",
      "poi_short_description": "Gym featuring obstacles and equipment inspired by the TV show \"American Ninja Warrior\", plus kids' parties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-7d48-7220-b4c0-8eb989b702ea.webp",
      "poi_featured_image_media": {
        "alt_text": "Indoor ninja warrior course with obstacle equipment and mats.",
        "public_id": "019d54f0-7d48-7220-b4c0-8eb989b702ea",
        "storage_key": "property/6767906449167333/019d54f0-7d48-7220-b4c0-8eb989b702ea.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.theriggym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8361556187026118978&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-rig-gym",
      "poi_latitude": "34.0836566",
      "poi_longitude": "-83.742076",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 470-478-2148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwyoX_6_l9YgRQlkp-Qw3CnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ad0ce0f8-d1c3-4442-8439-decff770de18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "960 Lee St Suite 120, Jefferson, GA 30549, USA",
      "poi_short_description": "Chain gym featuring machines for exercise as well as clean facilities.",
      "poi_long_description": "Gym goers say this gym offers a wide variety of well-maintained equipment, including free weights, cable machines, and a traditional hack squat, as well as clean restrooms and showers. They also highlight the friendly staff and the great value for the price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-7c2e-74af-a1c5-efa74ec92818.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Anytime Fitness gym with its logo and signage.",
        "public_id": "019d54f0-7c2e-74af-a1c5-efa74ec92818",
        "storage_key": "property/6767906449167333/019d54f0-7c2e-74af-a1c5-efa74ec92818.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/jefferson-georgia-5300/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=5300",
      "poi_directions_map_url": "https://maps.google.com/?cid=14476585492992468297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "34.1111666",
      "poi_longitude": "-83.586956",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 706-708-4088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2TTovVgJ9ogRSaVjPs4p58g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_986113d1-b791-4382-a36e-0f550ab8c335",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "NV Nails spa",
      "poi_type": "Health and Wellness",
      "poi_address": "85 Old Farm Rd, Jefferson, GA 30549, USA",
      "poi_short_description": "Clean salon offering a range of nail services and foot massages, plus massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-907c-73e7-abec-4b0278fb8b06.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a nail salon with rows of pedicure chairs and a reception desk.",
        "public_id": "019d54f0-907c-73e7-abec-4b0278fb8b06",
        "storage_key": "property/6767906449167333/019d54f0-907c-73e7-abec-4b0278fb8b06.webp",
        "width": 3072,
        "height": 1435
      },
      "poi_business_url": "https://nvnailsjefferson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14173039483687318673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nv-nails-spa",
      "poi_latitude": "34.125019",
      "poi_longitude": "-83.604418",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-708-2389",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ_JqaLjj9YgRkbTEhFHAsMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_ec547a3c-cc7b-43bd-9912-2793a1b41bcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Traditions Golf And Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "350 Traditions Way, Jefferson, GA 30549, USA",
      "poi_short_description": "Golf course with fairways and greens in great shape along with a driving range.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-96b0-738b-971a-f64b73f25cf0.webp",
      "poi_featured_image_media": {
        "alt_text": "Golf course with a pond and a green.",
        "public_id": "019d54f0-96b0-738b-971a-f64b73f25cf0",
        "storage_key": "property/6767906449167333/019d54f0-96b0-738b-971a-f64b73f25cf0.webp",
        "width": 1800,
        "height": 1120
      },
      "poi_business_url": "http://www.traditionsgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16676219782884068821&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "traditions-golf-and-country-club",
      "poi_latitude": "34.0974575",
      "poi_longitude": "-83.6963153",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-363-9963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e8b3-77b5-bc97-1aa9002e0f08.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing a person kicking a soccer ball",
        "public_id": "019d54f0-e8b3-77b5-bc97-1aa9002e0f08",
        "storage_key": "property/6767906449167333/019d54f0-e8b3-77b5-bc97-1aa9002e0f08.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UfZ1RXk9YgR1Y0lw4nVbec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_e2eb13f3-f47c-4285-94df-292d007ae092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Sell's Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8783 Jackson Trail Rd, Hoschton, GA 30558, USA",
      "poi_short_description": "Featuring a water mill from the early 1900s, this waterside park offers trails & a playground.",
      "poi_long_description": "People say this park offers a playground, swings, a pavilion with tables, and benches overlooking the water. They highlight the beautiful scenery, including a waterfall and an old mill, and the peaceful and relaxing atmosphere, ideal for picnics. They also like the short nature trail and the opportunity to walk in the river.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-9b6e-7148-a22d-6852cbf8dcd8.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered picnic pavilion with picnic tables in a grassy area with trees.",
        "public_id": "019d54f0-9b6e-7148-a22d-6852cbf8dcd8",
        "storage_key": "property/6767906449167333/019d54f0-9b6e-7148-a22d-6852cbf8dcd8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.jacksonrec.com/Facilities/Sells_Mill_Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11063780395930422521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sells-mill-park",
      "poi_latitude": "34.0847319",
      "poi_longitude": "-83.72992599999999",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-367-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
      "poi_map_icon_media": {
        "alt_text": "Tree icon",
        "public_id": "019d54f0-e97f-72fd-9776-e312468c71c6",
        "storage_key": "property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ346KrmUI9ogR-Qxd1KZxipk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a75f1b57-737e-49df-a231-157ad55d704d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Gum Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4889 GA-124, Hoschton, GA 30548, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-9bd5-7729-b37e-14edbc148895.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor playground and baseball fields with a cloudy sky.",
        "public_id": "019d54f0-9bd5-7729-b37e-14edbc148895",
        "storage_key": "property/6767906449167333/019d54f0-9bd5-7729-b37e-14edbc148895.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.jacksonrec.com/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=8605104707003784857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gum-springs-park",
      "poi_latitude": "34.0964774",
      "poi_longitude": "-83.68801750000002",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-367-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
      "poi_map_icon_media": {
        "alt_text": "Tree icon",
        "public_id": "019d54f0-e97f-72fd-9776-e312468c71c6",
        "storage_key": "property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgSRv1NXl9YgRmZ4ApCN5a3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6d9e4b0-d4da-48b5-b92f-1f03fce09612",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Braselton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "126 Harrison St, Braselton, GA 30517, USA",
      "poi_short_description": "Relaxed park featuring a playground and splash pad, plus benches and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-9e17-74d9-a561-0f9196a938cb.webp",
      "poi_featured_image_media": {
        "alt_text": "Children playing in a splash pad at a multifamily property.",
        "public_id": "019d54f0-9e17-74d9-a561-0f9196a938cb",
        "storage_key": "property/6767906449167333/019d54f0-9e17-74d9-a561-0f9196a938cb.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.braselton.net/locals/parks/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=2578875981194474818&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "braselton-park",
      "poi_latitude": "34.1064029",
      "poi_longitude": "-83.76444719999999",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-654-3915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
      "poi_map_icon_media": {
        "alt_text": "Tree icon",
        "public_id": "019d54f0-e97f-72fd-9776-e312468c71c6",
        "storage_key": "property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNQ8Yd2Dv9YgRQjXimgoCyiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9e64b200-8845-40d4-9b4f-bbb060b94e68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Jefferson Parks and Recreation Department",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2495 Old Pendergrass Rd, Jefferson, GA 30549, USA",
      "poi_short_description": "Leisure, sports and playground amenity featuring baseball and soccer fields, plus an after-school program.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-a144-722c-bde1-15247497528f.webp",
      "poi_featured_image_media": {
        "alt_text": "Young baseball player at bat, with catcher and umpire ready.",
        "public_id": "019d54f0-a144-722c-bde1-15247497528f",
        "storage_key": "property/6767906449167333/019d54f0-a144-722c-bde1-15247497528f.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.jeffersonga.gov/192/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=4491120662532458702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jefferson-parks-and-recreation-department",
      "poi_latitude": "34.1231573",
      "poi_longitude": "-83.6213931",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-367-5116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
      "poi_map_icon_media": {
        "alt_text": "Tree icon",
        "public_id": "019d54f0-e97f-72fd-9776-e312468c71c6",
        "storage_key": "property/6767906449167333/019d54f0-e97f-72fd-9776-e312468c71c6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJETncmvfi9YgRzgiqlXKqUz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f7630d2d-7065-4377-bcce-1bdfb7f55863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Carter's Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "625 Braselton Pkwy, Braselton, GA 30517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-b0e1-70d5-983b-d0d4c450a4d3.webp",
      "poi_featured_image_media": {
        "alt_text": "Carter's distribution center signage with address 625.",
        "public_id": "019d54f0-b0e1-70d5-983b-d0d4c450a4d3",
        "storage_key": "property/6767906449167333/019d54f0-b0e1-70d5-983b-d0d4c450a4d3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://carters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13054246421721976621&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carters-distribution-center",
      "poi_latitude": "34.1175459",
      "poi_longitude": "-83.7761003",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 762-232-1190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7E09Hnv9YgRLQ8nyfT_KbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d6e0c623-f9e5-42ae-bac3-34e18ca1ff00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Solmax (formerly TenCate Geosynthetics)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "365 S Holland Dr, Pendergrass, GA 30567, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-b52f-7121-8e0d-a4f316156583.webp",
      "poi_featured_image_media": {
        "alt_text": "Loading docks and office building exterior",
        "public_id": "019d54f0-b52f-7121-8e0d-a4f316156583",
        "storage_key": "property/6767906449167333/019d54f0-b52f-7121-8e0d-a4f316156583.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.solmax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5220321186330903797&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solmax-formerly-tencate-geosynthetics",
      "poi_latitude": "34.148961",
      "poi_longitude": "-83.65879980000001",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-693-2226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeh2kUHj9YgR9QSz5HVOckg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4ab32f31-31fb-4274-a0ff-9ff4f51a0b75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "RealTruck",
      "poi_type": "Major Employers & Offices",
      "poi_address": "502 Valentine Industrial Pkwy Ext, Pendergrass, GA 30567, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-c340-75f8-89bb-c65f22e467be.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large, modern building with a well-maintained lawn and paved road.",
        "public_id": "019d54f0-c340-75f8-89bb-c65f22e467be",
        "storage_key": "property/6767906449167333/019d54f0-c340-75f8-89bb-c65f22e467be.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://realtruck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16530277194928679409&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "realtruck",
      "poi_latitude": "34.1890384",
      "poi_longitude": "-83.64744069999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-241-2719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic.",
        "public_id": "019d54f0-e91a-73b8-92ba-c83c2ae8ebb4",
        "storage_key": "property/6767906449167333/019d54f0-e91a-73b8-92ba-c83c2ae8ebb4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0a9uShWT9YgR8el2EodXZ-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e35e7263-7edb-435b-9b49-60a799542450",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Hoschton City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "61 City Square St, Hoschton, GA 30548, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-cbdd-71ac-acb1-371e9d4b947f.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with green awnings and signage that reads \"City Hall\"",
        "public_id": "019d54f0-cbdd-71ac-acb1-371e9d4b947f",
        "storage_key": "property/6767906449167333/019d54f0-cbdd-71ac-acb1-371e9d4b947f.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.cityofhoschton.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5149588429234683091&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hoschton-city-hall",
      "poi_latitude": "34.0972364",
      "poi_longitude": "-83.76233739999999",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-654-3034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e978-7409-b363-399b8819c461.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54f0-e978-7409-b363-399b8819c461",
        "storage_key": "property/6767906449167333/019d54f0-e978-7409-b363-399b8819c461.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJye2Kxffl9YgR07z-h2QDd0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_942f222f-5e75-4a41-bf7c-abc3b09bc301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "poi_name": "Pendergrass City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "75 Glenn Gee Rd, Pendergrass, GA 30567, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-c601-72ad-a723-cb48fa47a9e4.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a church in the background.",
        "public_id": "019d54f0-c601-72ad-a723-cb48fa47a9e4",
        "storage_key": "property/6767906449167333/019d54f0-c601-72ad-a723-cb48fa47a9e4.webp",
        "width": 2560,
        "height": 1440
      },
      "poi_business_url": "https://cityofpendergrass.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11196760017977356419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pendergrass-city-hall",
      "poi_latitude": "34.1618011",
      "poi_longitude": "-83.67841159999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-693-2494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e978-7409-b363-399b8819c461.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54f0-e978-7409-b363-399b8819c461",
        "storage_key": "property/6767906449167333/019d54f0-e978-7409-b363-399b8819c461.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu5Bywqnk9YgRgzDW0unhYps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8b5b2e6b38eee8d11c479f7c",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1edd4f3cf2502e1f3b732c0a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3ee0edb06ea5dcacb243e9b5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5c7b5fff48693422aacf22bd",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_50cee238e62dc7e0f044f0ce",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_42878d80f6294c0b965704d8",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_13c8b74a1014d0f5e5813719",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_2f55798910133f8bf436e0d8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "rating": "5",
      "name": "Derrick Coleman",
      "text": "I’ve had a great experience living at this community! The office staff is friendly, professional, and always willing to help. The maintenance team is quick to respond and does quality work, which makes a big difference. The property is clean, well-maintained, and has a welcoming atmosphere. I truly appreciate how much the team cares about the residents and works hard to keep the community running smoothly. If you’re looking for a place to call home, I definitely recommend this apartment community!",
      "date": "2026-07-03",
      "title": "false"
    },
    {
      "id": "ec_847c24381c7896c338c0cb02",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "rating": "5",
      "name": "Angeliki Benardi",
      "text": "We are very happy with Kristen helping us out apply and register for our apartment in the Blakely! She has been very helpful with everything we needed so far.\nLovely place to live!\nCertain maintenance could be faster... But overall, very happy with our stay",
      "date": "2026-07-24",
      "title": "false"
    },
    {
      "id": "ec_adb467e4105d71a24ae5339f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "rating": "5",
      "name": "Crown Consortium LLC",
      "text": "Great place to live! The property is well maintained, and the manager Tayo is friendly, professional, and always quick to help me and my family. They truly care about the residents and make the community feel welcoming. Highly recommend!",
      "date": "2026-07-05",
      "title": "false"
    },
    {
      "id": "ec_d82d6f60ca49b7c27fe628c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "rating": "5",
      "name": "Evan Morgan",
      "text": "The apartment complex is clean, spacious, and set aside in a quiet part of Pendergrass. There is easy access to Gainesville and I-85 to still have lots of perks and ways to enjoy a good quality of life. Our Leasing consultant Kristen Pugh is incredible! She provided timely feedback and answers to any questions. Ask for her to get the best service! 10/10 would reccomend.",
      "date": "2026-04-26",
      "title": "false"
    },
    {
      "id": "ec_2863822565cdf86237c116d5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "rating": "4",
      "name": "Jadyn & Reyvin Crowley",
      "text": "We love it here! Great location. Few complaints about neighbors and such. Floors/walls are a little thin, but not unbearable. Place is cute, appliances and rooms are great. Maintenance seems to be prompt. Could use some landscaping or something (lots of dead/dying plants around). Helpful staff.",
      "date": "2026-04-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_531f9db6cdb8fed949a18571",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f2-efc7-76da-8eea-829cbffb8ea1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f2-efc7-76da-8eea-829cbffb8ea1",
        "storage_key": "property/6767906449167333/019d54f2-efc7-76da-8eea-829cbffb8ea1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 855SF (The Silas)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LTkbzzfom1L"
    },
    {
      "id": "ec_bb349f7d4cbfba1d893bec4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f2-efd3-705f-826a-452fdd27d81d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f2-efd3-705f-826a-452fdd27d81d",
        "storage_key": "property/6767906449167333/019d54f2-efd3-705f-826a-452fdd27d81d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1130SF (The Foster)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vm1GFe6prhY"
    },
    {
      "id": "ec_62350e6676fa3f6d45aeae06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f2-efe6-702e-b0e3-b3a446d8cbc5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f2-efe6-702e-b0e3-b3a446d8cbc5",
        "storage_key": "property/6767906449167333/019d54f2-efe6-702e-b0e3-b3a446d8cbc5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1cM8TK8dQjG"
    },
    {
      "id": "ec_bfc238788ef330343b6d2393",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f2-f057-72f6-9673-28b9834bbec4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f2-f057-72f6-9673-28b9834bbec4",
        "storage_key": "property/6767906449167333/019d54f2-f057-72f6-9673-28b9834bbec4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8pneS3XwREu"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-cb24-737b-a6a5-da324873cf6b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Blakely Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333"
    },
    {
      "lead_collector_id": "019db23f-cb98-778a-a919-d5e77484adb4",
      "lead_source": "FACEBOOK_ADS",
      "name": "The Blakely Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333"
    },
    {
      "lead_collector_id": "019db23f-cc0e-76e7-b960-7445a299f318",
      "lead_source": "LANDING_PAGE",
      "name": "The Blakely Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-pendergrass-ga-blakely",
      "search_query": "pet friendly apartments in Pendergrass GA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Pendergrass, GA",
      "h2_subtitle": "Discover The Blakely's pet welcoming community in Pendergrass, GA. Large spaces await both you and your beloved pets in a secure and joyful setting.",
      "page_copy": "Find the ideal home for you and your furry friends at The Blakely, renowned for its pet friendly apartments in Pendergrass, GA. Nestled in the serene Jackson County, our community offers spacious floor plans designed with both comfort and style in mind. Enjoy the convenience of stainless-steel appliances and the modern appeal of matte black accents, along with a gated community designed for comfortable living with your pets.\n\nOur state-of-the-art fitness center, featuring On Demand Fitness, and multiple fire pits provide perfect relaxation and recreation options after a day of pet adventures. With Pendergrass's charming surroundings and our community's welcoming atmosphere, The Blakely ensures that you and your pets will always feel at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Pendergrass, GA",
      "seo_description": "Discover pet friendly apartments at The Blakely in Pendergrass, GA. Enjoy spacious living for you and your pets with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "resort-style-pool-apartments-jackson-county-blakely",
      "search_query": "resort-style pool apartments in Jackson County",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments in Jackson County",
      "h2_subtitle": "Experience luxurious living with our resort-style pool apartments situated in scenic Jackson County. The Blakely offers unmatched amenities for a perfect lifestyle.",
      "page_copy": "Welcome to The Blakely, the standout choice for resort-style pool apartments in Jackson County. Our community is designed for those who crave an upscale living experience, complete with a state-of-the-art fitness center and beautifully appointed stainless-steel appliances. The spacious layouts and matte black accents add a touch of elegance to your everyday life.\n\nOur gated community, featuring controlled access and multiple fire pits, offers spaces for relaxation and enjoyment. Dive into luxury with our resort-style pool, perfect for unwinding under the sun. Located in the heart of Jackson County, The Blakely offers a harmonious blend of modern amenities and a serene lifestyle, making it the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments in Jackson County",
      "seo_description": "Explore resort-style pool apartments at The Blakely in Jackson County. Enjoy modern living with luxurious amenities and enhanced community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "state-of-the-art-fitness-center-pendergrass-blakely",
      "search_query": "state-of-the-art fitness center in Pendergrass",
      "category": "Amenity",
      "h1_title": "State-of-the-Art Fitness Center in Pendergrass",
      "h2_subtitle": "Elevate your fitness routine with The Blakely's state-of-the-art fitness center, offering cutting-edge equipment and On Demand Fitness in Pendergrass.",
      "page_copy": "At The Blakely, we prioritize your wellness with a state-of-the-art fitness center in Pendergrass, helping support your fitness routine and wellness goals. Our modern gym is fully equipped with the latest technology, including On Demand Fitness, providing you with the flexibility and tools needed for an invigorating workout experience.\n\nSituated in Jackson County, The Blakely offers more than just exercise facilities. Enjoy the luxury of stainless-steel appliances and matte black accents in every home. With amenities like multiple fire pits and gated, controlled access, our community fosters both health and relaxation. Discover a fitness-focused lifestyle complemented by comfort and convenience at The Blakely.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "State-of-the-Art Fitness Center in Pendergrass",
      "seo_description": "Discover The Blakely's state-of-the-art fitness center in Pendergrass. Enjoy modern amenities and flexible workout options with On Demand Fitness.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "apartments-ev-charging-near-30567-blakely",
      "search_query": "apartments with EV charging near 30567",
      "category": "Amenity",
      "h1_title": "Apartments with EV Charging Near 30567",
      "h2_subtitle": "Discover The Blakely's sustainable living solutions with apartments offering EV charging, conveniently located near the 30567 area.",
      "page_copy": "The Blakely stands out as a premier choice for apartments with EV charging near the 30567 area. As an environmentally conscious community, we provide convenient electric vehicle charging stations, allowing you to embrace a sustainable lifestyle without compromising on comfort.\n\nComplement your eco-friendly living with our spacious homes featuring stainless-steel appliances and matte black accents. Beyond green living, The Blakely offers multiple fire pits, a state-of-the-art fitness center with On Demand Fitness, and controlled, gated access. By choosing The Blakely, you not only gain a home but a community committed to modern living in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with EV Charging Near 30567",
      "seo_description": "Find environmentally-friendly apartments with EV charging at The Blakely near 30567. Experience modern living with sustainable solutions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "luxury-apartments-coworking-spaces-jackson-county-blakely",
      "search_query": "luxury apartments with coworking spaces in Jackson County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Coworking Spaces",
      "h2_subtitle": "Discover luxury living with coworking spaces at The Blakely in Jackson County, perfect for modern professionals seeking comfort and convenience.",
      "page_copy": "The Blakely offers a unique blend of luxury apartments with coworking spaces in Jackson County. Designed for modern living and productivity, our community provides the perfect environment to balance work and home. Each residence is adorned with stylish matte black accents and modern stainless-steel appliances that elevate your living experience.\n\nBeyond well-equipped coworking areas, residents benefit from a state-of-the-art fitness center with On Demand Fitness and multiple fire pits, all within our gated, controlled-access community. Embrace a lifestyle that supports both productivity and relaxation at The Blakely, where luxury meets functionality in the heart of Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Coworking in Jackson County",
      "seo_description": "Explore luxury apartments with coworking spaces at The Blakely, Jackson County. Ideal for professionals seeking a blend of comfort and productivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-pendergrass-ga-blakely",
      "search_query": "one bedroom apartments pendergrass ga",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Pendergrass, GA",
      "h2_subtitle": "Explore beautifully designed one bedroom apartments in Pendergrass, GA at The Blakely, perfect for comfortable and modern living.",
      "page_copy": "At The Blakely, our one bedroom apartments in Pendergrass, GA, offer the perfect blend of style and functionality. Each apartment features modern design elements like stainless-steel appliances and matte black accents, providing a chic living atmosphere.\n\nResidents enjoy premium amenities, including a state-of-the-art fitness center with On Demand Fitness, multiple fire pits for social gatherings, and gated, controlled-access community. Nestled in Jackson County, The Blakely provides not just a home, but a community, enhancing the living experience with a focus on comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Pendergrass, GA",
      "seo_description": "Find modern one bedroom apartments at The Blakely, Pendergrass, GA. Enjoy stylish living with top amenities in Jackson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-jackson-county-blakely",
      "search_query": "two bedroom apartments jackson county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Jackson County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Jackson County at The Blakely, where style meets comfort for modern living convenience.",
      "page_copy": "The Blakely offers generous two bedroom apartments in Jackson County that promise a comfortable and stylish living experience. Each apartment is thoughtfully designed with modern features like matte black accents and stainless-steel appliances, ensuring a sophisticated home environment.\n\nOur community enhances everyday living with a variety of amenities, such as a state-of-the-art fitness center with On Demand Fitness, multiple fire pits for relaxation, and secure, gated access. Situated in the serene setting of Pendergrass, The Blakely provides residents with a perfect blend of luxury and practical features, making it an ideal choice for a variety of lifestyles.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Jackson County",
      "seo_description": "Explore two bedroom apartments at The Blakely, Jackson County. Enjoy spacious living with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-30567-blakely",
      "search_query": "three bedroom apartments near 30567",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 30567",
      "h2_subtitle": "Find spacious three bedroom apartments near 30567 at The Blakely, perfect for families or those needing extra space.",
      "page_copy": "For those seeking three bedroom apartments near 30567, The Blakely offers an ideal living solution with generously sized layouts and modern features. Located in Pendergrass, these apartments are designed with both comfort and style in mind, showcasing matte black accents and stainless-steel appliances.\n\nThe community provides a range of amenities to enhance your lifestyle, including a state-of-the-art fitness center with On Demand Fitness, inviting fire pits, and gated, controlled access for peace of mind. With its blend of luxury and convenience, The Blakely is perfect for anyone who needs more space in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 30567",
      "seo_description": "Discover three bedroom apartments near 30567 at The Blakely. Enjoy spacious, modern living with top amenities in Pendergrass, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "apartments-near-sells-mill-park-pendergrass-blakely",
      "search_query": "apartments near sell's mill park pendergrass",
      "category": "Park",
      "h1_title": "Apartments Near Sell's Mill Park, Pendergrass",
      "h2_subtitle": "Discover apartments near Sell's Mill Park in Pendergrass at The Blakely, offering luxury living close to nature's tranquility.",
      "page_copy": "The Blakely is the perfect choice for those looking for apartments near Sell's Mill Park in Pendergrass. Located just a short drive from this beautiful natural spot, our community offers a serene living environment with both urban comforts and outdoor opportunities.\n\nOur residents enjoy stylish interiors featuring stainless-steel appliances and matte black accents, along with unmatched amenities like a state-of-the-art fitness center with On Demand Fitness, multiple fire pits, and gated access. Embrace a life of balance at The Blakely, where you can enjoy the tranquility of nearby Sell's Mill Park while still being part of a vibrant apartment community in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sell's Mill Park, Pendergrass",
      "seo_description": "Choose The Blakely for modern apartments near Sell's Mill Park in Pendergrass. Enjoy luxurious living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "apartments-close-to-gum-springs-park-ga-blakely",
      "search_query": "apartments close to gum springs park ga",
      "category": "Park",
      "h1_title": "Apartments Close to Gum Springs Park, GA",
      "h2_subtitle": "Experience living at The Blakely, offering modern apartments close to Gum Springs Park, GA, ideal for nature lovers and urban dwellers alike.",
      "page_copy": "The Blakely provides an exceptional living experience with our apartments close to Gum Springs Park, GA. Nestled in the peaceful town of Pendergrass, our community combines the best of modern living with the beauty of nearby natural attractions.\n\nResidents of The Blakely can enjoy interiors equipped with chic matte black accents and premium stainless-steel appliances. Our amenities are designed to fit a contemporary lifestyle, including a state-of-the-art fitness center with On Demand Fitness options, fire pits for social gatherings, and gated access. The proximity to Gum Springs Park makes it easy to explore the outdoors while enjoying luxurious apartment living in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Gum Springs Park, GA",
      "seo_description": "Explore The Blakely's apartments close to Gum Springs Park in GA. Enjoy a blend of nature and luxury living with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "braselton-park-nearby-apartments-30567-blakely",
      "search_query": "braselton park nearby apartments 30567",
      "category": "Park",
      "h1_title": "Braselton Park Nearby Apartments 30567",
      "h2_subtitle": "Explore The Blakely, featuring Braselton Park nearby apartments within the 30567 area, perfect for a balanced lifestyle.",
      "page_copy": "The Blakely offers Braselton Park nearby apartments in the 30567 region, with easy access to both urban conveniences and natural surroundings. Our community is strategically located near Braselton Park, making outdoor recreation part of everyday living.\n\nResidents enjoy thoughtfully designed interiors featuring matte black accents and stainless-steel appliances. Our state-of-the-art amenities include a fitness center with On Demand Fitness, multiple fire pits for relaxation, and gated access, offering comfort and convenience. Experience apartment living at The Blakely, where nearby Braselton Park and the lifestyle offerings of Jackson County come together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Braselton Park Nearby Apartments 30567",
      "seo_description": "Find Braselton Park nearby apartments at The Blakely in the 30567 area. Enjoy luxury living with top amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167333",
      "source": "custom",
      "page_item_url": "apartments-by-jefferson-parks-recreation-jackson-county-blakely",
      "search_query": "apartments by jefferson parks & recreation jackson county",
      "category": "Park",
      "h1_title": "Apartments by Jefferson Parks & Recreation",
      "h2_subtitle": "Live at The Blakely, offering apartments by Jefferson Parks & Recreation in Jackson County, perfect for those seeking leisure and convenience.",
      "page_copy": "The Blakely is perfectly positioned for those looking for apartments near Jefferson Parks & Recreation in Jackson County. Our location offers quick access to a variety of recreational facilities, making it an ideal choice for those who enjoy an active lifestyle.\n\nAt The Blakely, you'll find modern interiors featuring sophisticated matte black accents alongside stainless-steel appliances. Enjoy a range of impressive amenities, including a state-of-the-art fitness center with On Demand Fitness, inviting fire pits, and gated access. Embrace an elevated lifestyle near Jefferson Parks & Recreation while experiencing the comfort and convenience our community provides in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and a balcony.",
        "public_id": "019d54f0-e050-7790-8f14-a7b2c12006ee",
        "storage_key": "property/6767906449167333/019d54f0-e050-7790-8f14-a7b2c12006ee.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Jefferson Parks & Recreation",
      "seo_description": "Discover The Blakely's luxurious apartments by Jefferson Parks & Recreation in Jackson County, offering premium amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6076"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671070103"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PHB4QWSC"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script>Object.assign(window, {websiteToken: 'j3DFbkgiAcxM8aCgn3vojism', siteConfig: {clt_i: \"102052\", property_id: \"100160120\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9725722006"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "588b60511ee51ae3"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "373847215"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/5evejdo2wqo"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "55a373941c2d71bf3079"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a13371c6-d0cb-11f0-a5a2-9b0b386c7967"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a13371c6-d0cb-11f0-a5a2-9b0b386c7967/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjVtQmVmNG5zUU9Ka3pQeC9SaE5xM2c9PSIsInZhbHVlIjoiSDl6OHVITkh5QTVkNFNHUGRobTE4Zz09IiwibWFjIjoiMjMzZDFiN2Q1YWY4NTgxNjYzZDMzODNlNDlhZGU3NWY5ZjkxYWY2YWQxMzcxZTk0NGQ3MzdmYTM4ZjljNTVmNCJ9"
    }
  ],
  "custom_qb_id": "6076",
  "custom_repli_id": "11671070103",
  "custom_google_gtm_id": "GTM-PHB4QWSC",
  "custom_entrata_chatbot": "<script>Object.assign(window, {websiteToken: 'j3DFbkgiAcxM8aCgn3vojism', siteConfig: {clt_i: \"102052\", property_id: \"100160120\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>",
  "custom_hubspot_company_id": "9725722006",
  "custom_knock_community_id": "588b60511ee51ae3",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "373847215",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/5evejdo2wqo",
  "custom_call_rail_account_hash": "55a373941c2d71bf3079",
  "custom_eliseai_building_token": "a13371c6-d0cb-11f0-a5a2-9b0b386c7967",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a13371c6-d0cb-11f0-a5a2-9b0b386c7967/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjVtQmVmNG5zUU9Ka3pQeC9SaE5xM2c9PSIsInZhbHVlIjoiSDl6OHVITkh5QTVkNFNHUGRobTE4Zz09IiwibWFjIjoiMjMzZDFiN2Q1YWY4NTgxNjYzZDMzODNlNDlhZGU3NWY5ZjkxYWY2YWQxMzcxZTk0NGQ3MzdmYTM4ZjljNTVmNCJ9",
  "custom_audioeye_site_id": "b1d6d9bf-c67d-4c5c-9a3a-a9f483f7910d",
  "custom_audioeye_site_hash": "91cf6696048e4613be9a0502d265381c"
};

export const generatedAt = '2026-10-01T17:23:37.269Z';
